export default "__VITE_ASSET__CU10lUJd__"